import React from 'react';
import { useNavigate } from 'react-router-dom';
import CareersImage from "../../Assets/Images/careers.png";
import { Box, Typography, Link, List, ListItem, ListItemText } from "@mui/material";
import { COURSE_CATEGORIES } from '../../Infrastructure/Constants/courseCategories';
import { careersSx } from './styles'

export const CareersView = ({ jobListings, handleScroll, listingsRef }) => {
    const navigate = useNavigate()
    const getCategoryLabel = (name) => {
        const found = COURSE_CATEGORIES.find((cat) => cat.name === name)
        return found ? found.label : name
    };
    return (
    <Box sx={careersSx.root}>
      <Box sx={careersSx.heroContainer}>
        <Box sx={careersSx.heroContent}>
          <Box sx={careersSx.heroTextBox}>
            <Typography sx={careersSx.heroTitle} color="primary" gutterBottom>
              Re-Inventing <br /> Education
            </Typography>
            <Typography sx={careersSx.heroSubtitle}>
              Together, we will bring Education into the 21st century
            </Typography>
          </Box>
          <Box sx={careersSx.heroImageBox}>
            <img src={CareersImage} alt="Team working together" width="100%" height="100%" style={{ objectFit: 'cover' }} />
          </Box>
        </Box>
        <Box sx={careersSx.seeOpportunitiesBox}>
          <Typography component="span" sx={careersSx.seeOpportunitiesText} onClick={handleScroll}>
            See Open Opportunities
          </Typography>
        </Box>
      </Box>
      <Box ref={listingsRef} sx={careersSx.listingsContainer}>
        <Box height="90px" />
        <Typography sx={careersSx.listingsTitle} gutterBottom>
          Our Current Opportunities
        </Typography>
        <Box sx={careersSx.divider} />
        {jobListings?.length > 0 ? (
          jobListings.map((category, index) => (
            <Box key={index} my={4}>
              <Typography sx={careersSx.categoryTitle} gutterBottom>
                {getCategoryLabel(category.category)}
              </Typography>
              <List>
                {category?.jobs?.map((job, idx) => (
                  <ListItem key={idx} sx={careersSx.jobItem}>
                    <Box sx={careersSx.jobRow}>
                      <ListItemText

                        primary={<Link component="button" sx={careersSx.jobLink} onClick={() => navigate(job.link)}>{job.title}{job.subtitle ? ` - ${job.subtitle}` : ""}</Link>}/>
                      <Typography color="textSecondary" sx={careersSx.jobLocation}>
                        {job.location || ""}
                      </Typography>
                    </Box>
                    <Box sx={careersSx.jobDivider} />
                  </ListItem>
                ))}
              </List>
            </Box>
          ))
        ) : (
          <Typography sx={careersSx.emptyState}>
            No job opportunities available at the moment. Please check back later.
          </Typography>
        )}
      </Box>
    </Box>
  );
};
